import { Formik, Form, Field } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import Box from "../components/Box/Box";
import Progressbar from "../components/Progressbar/Progressbar";
import ErrorList from "../components/Form/ErrorList";
import { useEffect, useRef } from "react";
import { handleSubmitClick } from "../components/Form/FormUtils";
import BackButton from "../components/Buttons/BackButton";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { MultipleFileUploadField } from "../components/FileUpload/MultipleFileUploadField";
import Textarea from "../components/Form/Textarea";
import InputText from "../components/Form/InputText";
import RadioGroup from "../components/Form/RadioGroup";
import { NO_TICKET, WITH_APP, WITH_BLIP, WITH_TICKET, WITH_TRAVELCARD } from "./TicketType";

export default function TicketWithApp() {
    const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
    const [formData, setFormData] = useAtom(formDataAtom);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);
    
    return (
        <div>
            <Formik<FormModel>
                onSubmit={(values) => {
                    setFormData({
                        ...formData,
                        ...values,
                    });

                    navigate("/vad-var-det-som-hande");
                }}
                initialValues={{
                    ...formData,
                }}
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                validationSchema={Yup.object().shape({
                    ticketNumber: Yup.string().required(
                        "Vänligen fyll i det mobilnummer som används i appen."
                    ),
                })}
            >
                {({ errors, values }) => (
                    <>
                        <div className="flex justify-end items-center">
                            <div className="xs:w-52 md:w-full max-w-xs">
                                <Progressbar percentage={"33"} />
                            </div>
                        </div>
                        
                        <Form noValidate>
                            <Box>
                                <h2 ref={h2Ref} tabIndex={-1} id="appTicketHeading">
                                    Biljetten fanns i appen
                                </h2>

                                <p>
                                    För att gå vidare behöver vi ha det mobilnummer som är kopplat till appen där biljetten fanns.
                                </p>

                                {Object.keys(errors).length > 0 && <ErrorList errors={errors} />}

                                <InputText
                                    name="ticketNumber"
                                    label={
                                        <>
                                            Mobilnummer <span>(Obligatoriskt)</span>
                                        </>
                                    }
                                    type="tel"
                                    autocomplete={"tel"}
                                    numbersOnly
                                />
                            </Box>

                            <div className="flex justify-center">
                                <div className="w-full text-left flex items-center">
                                    <BackButton />
                                </div>
                                <div className="w-full text-right">
                                    <button
                                        onClick={handleSubmitClick(formRef)}
                                        className="btn primary"
                                        type="submit"
                                    >
                                        Gå vidare
                                    </button>
                                </div>
                            </div>

                        </Form>
                    </>
                )}
            </Formik>
        </div>
    );
}
